export const getFromUrl = () => {
  return `/panel${window.location.href.split('/panel')[1]}`;
};
